import { createDeploymentService } from "../../../../services/deploymentServices";
import buildDeploymentBody from "../build-deployment-body";

export const handleSubmit = ({ history }) => values => {
  return new Promise((resolve, reject) => {
    createDeploymentService(
      { body: buildDeploymentBody(values) },
      data => {
        if (data?._id) {
          history.replace(`/deployment/details/${data._id}`);
        }
        resolve();
      },
      e => {
        reject(e);
      },
    );
  });
};
